import { observable } from 'mobx';

export type GradeResponseArgs = {
  id: number;
  name: string;
};

export type GradeArgs = {
  id: number;
  name: string;
};

export const convertGradeResponseToArgs = (response: GradeResponseArgs) => {
  const args: GradeArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class Grade {
  @observable id: number;
  @observable name: string;

  constructor(args: GradeArgs) {
    this.id = args.id;
    this.name = args.name;
  }
}
